import { Card, Col, Row, Space, Typography } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import React from 'react'
import { SegmentType } from '.'
const { Title } = Typography

const IULCard = ({ position, initValues, handleSetIuls, handleRemove }) => {
    let values = { ...initValues }
    delete values.type
    return (
        <>
            <Col span={1}></Col>
            <Col span={10}>
                <Card
                    style={{
                        width: '100%',
                    }}
                >
                    <Space
                        direction="vertical"
                        size="middle"
                        style={{ display: 'flex' }}
                    >
                        <Row>
                            <Col span={20}>
                                <Title level={5}>IUL</Title>
                            </Col>
                            <Col span={4}>
                                <CloseCircleOutlined
                                    style={{ fontSize: '18px', color: 'red' }}
                                    onClick={() =>
                                        handleRemove(SegmentType.iul, position)
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="material-textfield">
                                    <input
                                        placeholder=""
                                        type="text"
                                        name="totalPremium"
                                        onChange={(e) => {
                                            handleSetIuls(
                                                position,
                                                'totalPremium',
                                                e.target.value
                                            )
                                        }}
                                        value={values.totalPremium}
                                        className="material-textfield-input"
                                    />
                                    <label
                                        style={{
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Total premium
                                    </label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="material-textfield">
                                    <input
                                        placeholder=""
                                        type="text"
                                        name="annualIncome"
                                        onChange={(e) => {
                                            handleSetIuls(
                                                position,
                                                'annualIncome',
                                                e.target.value
                                            )
                                        }}
                                        value={values.annualIncome}
                                        className="material-textfield-input"
                                    />
                                    <label
                                        style={{
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Annual income
                                    </label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="material-textfield">
                                    <input
                                        placeholder=""
                                        type="text"
                                        name="increasePercentage"
                                        onChange={(e) => {
                                            handleSetIuls(
                                                position,
                                                'increasePercentage',
                                                e.target.value
                                            )
                                        }}
                                        value={values.increasePercentage}
                                        className="material-textfield-input"
                                    />
                                    <label
                                        style={{
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Increase %
                                    </label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="material-textfield">
                                    <input
                                        placeholder=""
                                        type="text"
                                        name="startYear"
                                        onChange={(e) => {
                                            handleSetIuls(
                                                position,
                                                'startYear',
                                                e.target.value
                                            )
                                        }}
                                        value={values.startYear}
                                        className="material-textfield-input"
                                    />
                                    <label
                                        style={{
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Start year
                                    </label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="material-textfield">
                                    <input
                                        placeholder=""
                                        type="text"
                                        name="endYear"
                                        onChange={(e) => {
                                            handleSetIuls(
                                                position,
                                                'endYear',
                                                e.target.value
                                            )
                                        }}
                                        value={values.endYear}
                                        className="material-textfield-input"
                                    />
                                    <label
                                        style={{
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        End year
                                    </label>
                                </div>
                            </Col>
                        </Row>
                    </Space>
                </Card>
            </Col>
        </>
    )
}

export default IULCard
